import script from "./MonthsPicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./MonthsPicker.vue?vue&type=script&lang=ts&setup=true"

import "./MonthsPicker.vue?vue&type=style&index=0&id=63919254&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63919254"]])

export default __exports__